import type { LucideIcon } from 'lucide-react'
import { ICON_CATALOG_DATA, ICON_REGISTRY, type CatalogIcon } from './iconCatalog.data'

/** Иконка каталога: имя lucide (PascalCase) + краткое описание (2-3 слова) для поиска/подбора ИИ.
 *  Объявлен в модуле данных (иначе данные зависели бы от своего же потребителя),
 *  наружу торчит отсюда — фасад у каталога один. */
export type { CatalogIcon } from './iconCatalog.data'

/** Публичный каталог иконок для бейджей (данные — см. iconCatalog.data.ts) */
export const ICON_CATALOG: CatalogIcon[] = ICON_CATALOG_DATA

/**
 * Вернуть React-компонент lucide-иконки по PascalCase-имени, либо `null`,
 * если имя не резолвится. `ICON_REGISTRY` собран из явных именованных импортов
 * только тех иконок, что есть в каталоге, поэтому служебные экспорты
 * lucide-react (`icons`, `createLucideIcon` и т.п.) в нём отсутствуют.
 * Проверка на собственное свойство обязательна: реестр — объектный литерал,
 * и без неё `getLucideIcon('toString')` вернул бы унаследованный метод
 * `Object.prototype` вместо `null`.
 */
export const getLucideIcon = (name?: string | null): LucideIcon | null => {
  if (!name) return null
  return Object.prototype.hasOwnProperty.call(ICON_REGISTRY, name)
    ? (ICON_REGISTRY[name] ?? null)
    : null
}
